// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class Singleton {
    protected static instance: Singleton;

    public static getInstance<T extends typeof Singleton>(
        this: T,
    ): InstanceType<T> {
        this.instance ??= new this() as InstanceType<T>;
        return this.instance as InstanceType<T>;
    }
}
